import { Subscriber, merge, Observable, isObservable, Subscription, Observer } from 'rxjs';
import { mergeAll } from 'rxjs/operators';

const ERRORS = {
    HEADER: `
    MergeHotStreamHandlerArraySubscriber Error.

    `,
    NOT_A_FUNCTION: `
    Supplied handler ignored: It is not a function

    `,
    NOT_AN_OBSERVABLE: `
    Supplied handler ignored: It does not return an observable

    `
};

type HotStreamHandler = ( (action: any) => Observable<any> );

class MergeHotStreamHandlerArraySubscriber extends Subscriber<any> {

    private _handlers: HotStreamHandler[] = [];

    constructor(
        sub: Observer<any>,
        effects: HotStreamHandler[]
    ) {
        super(sub);
        this._handlers = effects || this._handlers;
    }

    _next(value: any): void {

        const inner$ = merge(
            this._handlers
            .filter( (handler: HotStreamHandler) => {

                const condition = typeof handler === 'function';

                if ( !condition ) {
                    console.warn(ERRORS.HEADER + ERRORS.NOT_A_FUNCTION, handler);
                }

                return condition;
            })
            .filter( (handler: HotStreamHandler) => {

                const condition = isObservable(handler(value));

                if ( !condition ) {
                    console.warn(ERRORS.HEADER + ERRORS.NOT_AN_OBSERVABLE, handler);
                }

                return condition;
            })
            .map(
                (handler: HotStreamHandler) => {
                    return handler(value);
                }
            ),
        ).pipe( mergeAll() );

        inner$.subscribe({
            next: ( v: any ) => {
                this.destination.next(v);
            }
        });
    }
}

export const mergeHotStreamHandlerArray = handlers => source => source.lift({
    call(sub: Observer<any>, s: Observable<any>) {
        s.subscribe(new MergeHotStreamHandlerArraySubscriber(sub, handlers));
    }
});

